import httpInstances from '@/api/axiosInstance';
import { parseFromToISO } from '@/utils/parseFromToISO';

type QueryFormat = 'json' | 'csv';

const ACCEPT_HEADERS: Record<QueryFormat, string> = {
  json: 'application/json',
  csv: 'text/csv'
};

const queryApi = async (queryId: string, from: string | undefined, format: QueryFormat) => {
  const parsedFrom = parseFromToISO(from);
  const response = await httpInstances.axiosInternalInstance.get(
    `/duck/${queryId}?mode=turbo&from=${parsedFrom}`,
    { headers: { Accept: ACCEPT_HEADERS[format] } }
  );

  if (response.status !== 200) {
    throw new Error(`Query execution failed for ID '${queryId}' with status ${response.status}`);
  }

  if (format === 'csv') {
    return response.data as string;
  }

  const { data } = response;
  return Array.isArray(data) ? data : [data];
};

export const queryApiById = async (queryId: string, from: string | undefined) => {
  return queryApi(queryId, from, 'json');
};

export const queryApiByIdString = async (queryId: string, from?: string) => {
  return queryApi(queryId, from, 'csv') as Promise<string>;
};
